/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PublicMatchOperationV2Player } from './PublicMatchOperationV2Player';
import {
    PublicMatchOperationV2PlayerFromJSON,
    PublicMatchOperationV2PlayerFromJSONTyped,
    PublicMatchOperationV2PlayerToJSON,
    PublicMatchOperationV2PlayerToJSONTyped,
} from './PublicMatchOperationV2Player';

/**
 * 
 * @export
 * @interface PublicMatchOperationV2Team
 */
export interface PublicMatchOperationV2Team {
    /**
     * 
     * @type {string}
     * @memberof PublicMatchOperationV2Team
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PublicMatchOperationV2Team
     */
    name?: string | null;
    /**
     * 
     * @type {Array<PublicMatchOperationV2Player>}
     * @memberof PublicMatchOperationV2Team
     */
    players: Array<PublicMatchOperationV2Player>;
}

/**
 * Check if a given object implements the PublicMatchOperationV2Team interface.
 */
export function instanceOfPublicMatchOperationV2Team(value: object): value is PublicMatchOperationV2Team {
    if (!('players' in value) || value['players'] === undefined) return false;
    return true;
}

export function PublicMatchOperationV2TeamFromJSON(json: any): PublicMatchOperationV2Team {
    return PublicMatchOperationV2TeamFromJSONTyped(json, false);
}

export function PublicMatchOperationV2TeamFromJSONTyped(json: any, ignoreDiscriminator: boolean): PublicMatchOperationV2Team {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'players': ((json['players'] as Array<any>).map(PublicMatchOperationV2PlayerFromJSON)),
    };
}

export function PublicMatchOperationV2TeamToJSON(json: any): PublicMatchOperationV2Team {
    return PublicMatchOperationV2TeamToJSONTyped(json, false);
}

export function PublicMatchOperationV2TeamToJSONTyped(value?: PublicMatchOperationV2Team | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'players': ((value['players'] as Array<any>).map(PublicMatchOperationV2PlayerToJSON)),
    };
}

